export default __webpack_public_path__ + "static/OpenSans-Bold-08328bf7467540700abeb7718042f955.woff";